export default function SunCloudIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512" stroke="var(--color-secondary)" strokeWidth="32px">
      <path d="M384.8,271.4a80,80,0,1,0-123.55-92" fill="transparent" stroke="var(--orange)" />
      <path d="M90.61,306.85A16.07,16.07,0,0,0,104,293.6C116.09,220.17,169.63,176,232,176c57.93,0,96.62,37.75,112.2,77.74a15.84,15.84,0,0,0,12.2,9.87c50,8.15,91.6,41.54,91.6,99.59C448,422.6,399.4,464,340,464H106c-49.5,0-90-24.7-90-79.2C16,336.33,54.67,312.58,90.61,306.85Z" fill="transparent" />
      <line x1="464" y1="208" x2="496" y2="208" stroke="var(--orange)" strokeLinecap="round" />
      <line x1="336" y1="48" x2="336" y2="80" stroke="var(--orange)" strokeLinecap="round" />
      <line x1="222.86" y1="94.86" x2="245.49" y2="117.49" stroke="var(--orange)" strokeLinecap="round" />
      <line x1="449.14" y1="94.86" x2="426.51" y2="117.49" stroke="var(--orange)" strokeLinecap="round" />
    </svg>
  )
}
